import { reactive } from "vue";
import { setCurrentLangDataFn } from '@template/utils';
const langState = reactive({
    langData: {},
});

const setCurrentLangData = async (langList, langCode = null, init = true, langAws) => {
	try{
		if(langCode == 'en'){
			langState.langData = {}
			localStorage.removeItem('selectedLanguageCode');
			return
		}
		let response = await setCurrentLangDataFn(langList, langCode, init, langAws);
		if(!response?.errorMessage){
			langState.langData = response;
		}
		return response
	}
	catch(error){
		console.log(error)
		return {'error' : error}
	}

};

const translatedData = (key, defaultVal) => {
	if (langState.langData?.[key]) {
		return langState.langData?.[key];
	} else {
		return defaultVal;
	}
};

export {setCurrentLangData, translatedData};